
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { useState } from 'react';
const CreateProvider = () => {
    const [t] = useTranslation()
    const [inputData, setInputData] = useState({
        name: '',
        shortname: '',
        email: '',
        taxcode: '',
        address: ''
    })
    return (
        <div>
            <h1>{t('Đơn vị vận chuyển')}</h1>
            <TextField
            label={t('Tên')}
            value={inputData.name}
            onChange={e => setInputData(prev => ({...prev, name: e.target.value}))}
            fullWidth
            sx={{margin: '5px 0'}}
            />
            <TextField
            label={t('Tên ngắn')}
            value={inputData.shortname}
            onChange={e => setInputData(prev => ({...prev, shortname: e.target.value}))}
            fullWidth
            sx={{margin: '5px 0'}}
            />
            <TextField
            label="Email"
            value={inputData.email}
            onChange={e => setInputData(prev => ({...prev, email: e.target.value}))}
            fullWidth
            sx={{margin: '5px 0'}}
            />
            <TextField
            label='Tax'
            value={inputData.taxcode}
            onChange={e => setInputData(prev => ({...prev, taxcode: e.target.value}))}
            fullWidth
            sx={{margin: '5px 0'}}
            />
            <TextField
            label={t('Địa chỉ')}
            value={inputData.address}
            onChange={e => setInputData(prev => ({...prev, address: e.target.value}))}
            fullWidth
            sx={{margin: '5px 0'}}
            />
        </div>
    )
}
export default CreateProvider